
<svg aria-hidden="true" width="24" height="24" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
  <title>Small, lined calendar icon</title>
  <path d="M13 12V10H15V12H13Z" fill="currentColor" />
  <path d="M15 15V13H13V15H15Z" fill="currentColor" />
  <path d="M5 18V16H7V18H5Z" fill="currentColor" />
  <path d="M11 16H9V18H11V16Z" fill="currentColor" />
  <path d="M15 18V16H13V18H15Z" fill="currentColor" />
  <path d="M9 13H11V15H9V13Z" fill="currentColor" />
  <path d="M7 13H5V15H7V13Z" fill="currentColor" />
  <path d="M11 10H9V12H11V10Z" fill="currentColor" />
  <path d="M5 10H7V12H5V10Z" fill="currentColor" />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16 2V0L14 0V2H6V0L4 0V2H2C0.89543 2 0 2.89543 0 4L0 20C0 21.1046 0.89543 22 2 22H18C19.1046 22 20 21.1046 20 20V4C20 2.89543 19.1046 2 18 2H16ZM18 4V6H2V4H18ZM2 20V8H18V20H2Z"
    fill="currentColor"
  />
</svg>
